import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import './LegalPages.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <Link to="/" className="back-link">
          <ArrowLeft size={20} />
          <span>Înapoi la Pagina Principală</span>
        </Link>

        <div className="legal-header">
          <Shield size={48} />
          <h1>Politica de Confidențialitate</h1>
          <p className="legal-updated">Ultima actualizare: 25 August 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Introducere</h2>
            <p>
              <strong>MULTIPOWER TOUR SRL</strong> respectă confidențialitatea datelor dumneavoastră
              personale și se angajează să le protejeze în conformitate cu Regulamentul General privind
              Protecția Datelor (GDPR) și legislația română aplicabilă.
            </p>
            <div className="company-info">
              <h3>Operator de Date:</h3>
              <ul>
                <li><strong>MULTIPOWER TOUR SRL</strong></li>
                <li>Str. Zefirului, Nr.19, Mun. Dorohoi, Jud. Botoșani</li>
                <li>Tel: +4-0740-824.224</li>
                <li>Email: multipowertour@yahoo.com</li>
                <li>Web: https://multipowertour.ro</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>2. Date Colectate</h2>
            <h3>2.1 Date Personale de Identificare</h3>
            <ul>
              <li>Nume și prenume</li>
              <li>Adresă de email</li>
              <li>Număr de telefon</li>
              <li>Adresă poștală (opțional)</li>
              <li>Data nașterii (pentru reduceri/abonamente speciale)</li>
            </ul>

            <h3>2.2 Date de Autentificare</h3>
            <ul>
              <li>Nume utilizator</li>
              <li>Parolă (criptată)</li>
              <li>Informații despre dispozitiv</li>
              <li>Adresă IP</li>
            </ul>

            <h3>2.3 Date de Plată</h3>
            <ul>
              <li>Informații despre cardul bancar (procesate securizat prin procesatori de plăți certificați)</li>
              <li>Istoric tranzacții</li>
              <li>Facturi și chitanțe</li>
            </ul>

            <h3>2.4 Date de Călătorie</h3>
            <ul>
              <li>Istoric călătorii</li>
              <li>Rute preferate</li>
              <li>Locații de îmbarcare/debarcare</li>
              <li>Bilete achiziționate</li>
              <li>Abonamente active</li>
            </ul>

            <h3>2.5 Date de Localizare</h3>
            <ul>
              <li>Poziția GPS (doar când aplicația este activă și cu acordul dvs.)</li>
              <li>Stații apropiate</li>
              <li>Rute calculate</li>
            </ul>

            <h3>2.6 Date Tehnice</h3>
            <ul>
              <li>Tip dispozitiv și sistem de operare</li>
              <li>Versiune aplicație</li>
              <li>Cookies și date de navigare</li>
              <li>Loguri de utilizare</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Scopul Prelucrării Datelor</h2>
            <p>Datele dumneavoastră personale sunt prelucrate pentru următoarele scopuri:</p>

            <h3>3.1 Furnizarea Serviciilor</h3>
            <ul>
              <li>Crearea și gestionarea contului de utilizator</li>
              <li>Procesarea achizițiilor de bilete și abonamente</li>
              <li>Furnizarea informațiilor despre curse și orare</li>
              <li>Notificări despre sosirea vehiculelor</li>
            </ul>

            <h3>3.2 Îmbunătățirea Serviciilor</h3>
            <ul>
              <li>Analiză statistică a utilizării aplicației</li>
              <li>Optimizarea rutelor și orarelor</li>
              <li>Dezvoltarea de noi funcționalități</li>
            </ul>

            <h3>3.3 Comunicare</h3>
            <ul>
              <li>Trimiterea de notificări importante</li>
              <li>Răspunsuri la solicitări de suport</li>
              <li>Newsletter și oferte (doar cu acordul dvs.)</li>
            </ul>

            <h3>3.4 Conformitate Legală</h3>
            <ul>
              <li>Respectarea obligațiilor legale</li>
              <li>Emiterea facturilor fiscale</li>
              <li>Răspunsuri la solicitări ale autorităților</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Temei Legal al Prelucrării</h2>
            <p>Prelucrăm datele dumneavoastră pe baza următoarelor temeiuri legale:</p>
            <ul>
              <li><strong>Executarea contractului:</strong> pentru furnizarea serviciilor de transport</li>
              <li><strong>Consimțământ:</strong> pentru marketing și localizare</li>
              <li><strong>Interes legitim:</strong> pentru îmbunătățirea serviciilor și securitate</li>
              <li><strong>Obligații legale:</strong> pentru emiterea facturilor și raportări fiscale</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Partajarea Datelor</h2>
            <p>
              Multipower Tour nu vinde datele dumneavoastră personale. Acestea pot fi partajate doar cu:
            </p>

            <h3>5.1 Procesatori de Plăți</h3>
            <p>
              Pentru procesarea tranzacțiilor (de ex. Stripe, PayPal) - conform standardelor PCI DSS
            </p>

            <h3>5.2 Furnizori de Servicii Cloud</h3>
            <p>
              Pentru hosting și backup (de ex. AWS, Google Cloud) - cu acorduri de confidențialitate
            </p>

            <h3>5.3 Autorități</h3>
            <p>
              Când este cerut de lege sau pentru protejarea drepturilor noastre
            </p>

            <h3>5.4 Parteneri de Analiză</h3>
            <p>
              Date anonimizate pentru analiză statistică (de ex. Google Analytics)
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Securitatea Datelor</h2>
            <p>Implementăm măsuri tehnice și organizatorice pentru protecția datelor:</p>
            <ul>
              <li>Criptare SSL/TLS pentru transmiterea datelor</li>
              <li>Criptarea parolelor cu algoritmi moderni</li>
              <li>Firewall și sisteme de detectare a intruziunilor</li>
              <li>Backup regulat și plan de recuperare după dezastre</li>
              <li>Acces restricționat pe bază de nevoi</li>
              <li>Instruirea personalului privind securitatea datelor</li>
              <li>Auditări periodice de securitate</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Perioada de Stocare</h2>
            <p>Păstrăm datele dumneavoastră pentru următoarele perioade:</p>
            <ul>
              <li><strong>Date de cont activ:</strong> până la ștergerea contului</li>
              <li><strong>Istoric tranzacții:</strong> 5 ani (obligații fiscale)</li>
              <li><strong>Facturi:</strong> 10 ani (conform Codului Fiscal)</li>
              <li><strong>Date de marketing:</strong> până la retragerea consimțământului</li>
              <li><strong>Loguri tehnice:</strong> 12 luni</li>
            </ul>
            <p>
              După expirarea acestor perioade, datele sunt șterse sau anonimizate.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Drepturile Dumneavoastră</h2>
            <p>În conformitate cu GDPR, aveți următoarele drepturi:</p>

            <h3>8.1 Dreptul de Acces</h3>
            <p>
              Puteți solicita o copie a datelor personale pe care le deținem despre dumneavoastră.
            </p>

            <h3>8.2 Dreptul de Rectificare</h3>
            <p>
              Puteți corecta datele inexacte sau incomplete direct din aplicație sau contactându-ne.
            </p>

            <h3>8.3 Dreptul de Ștergere ("Dreptul de a fi uitat")</h3>
            <p>
              Puteți solicita ștergerea datelor, cu excepția celor necesare pentru obligații legale.
            </p>

            <h3>8.4 Dreptul de Restricționare</h3>
            <p>
              Puteți solicita restricționarea prelucrării în anumite circumstanțe.
            </p>

            <h3>8.5 Dreptul la Portabilitate</h3>
            <p>
              Puteți primi datele într-un format structurat pentru transfer la alt operator.
            </p>

            <h3>8.6 Dreptul de Opoziție</h3>
            <p>
              Puteți obiecta la prelucrarea pentru marketing direct sau în baza interesului legitim.
            </p>

            <h3>8.7 Retragerea Consimțământului</h3>
            <p>
              Puteți retrage oricând consimțământul pentru marketing sau localizare.
            </p>

            <h3>Exercitarea Drepturilor</h3>
            <p>
              Pentru exercitarea acestor drepturi, contactați-ne la <a href="mailto:multipowertour@yahoo.com">multipowertour@yahoo.com</a>
              <br />Vom răspunde în termen de 30 de zile.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Transferuri Internaționale</h2>
            <p>
              Datele dumneavoastră sunt stocate pe servere situate în Uniunea Europeană. Dacă este
              necesar un transfer în afara UE, ne asigurăm că destinatarul oferă garanții adecvate
              conform GDPR (de ex. clauzele contractuale standard).
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Cookies și Tehnologii Similare</h2>
            <p>
              Utilizăm cookies și tehnologii similare. Pentru detalii, consultați
              <Link to="/cookies"> Politica de Cookies</Link>.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Minori</h2>
            <p>
              Serviciile noastre nu sunt destinate copiilor sub 13 ani. Nu colectăm în mod conștient
              date de la minori fără acordul părinților. Dacă descoperiți că un minor a furnizat date,
              vă rugăm să ne contactați pentru ștergerea acestora.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Modificări ale Politicii</h2>
            <p>
              Ne rezervăm dreptul de a actualiza această politică. Veți fi notificați prin email sau
              notificare în aplicație cu privire la modificările semnificative. Data ultimei actualizări
              este afișată în partea de sus a documentului.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Plângeri</h2>
            <p>
              Dacă considerați că drepturile dumneavoastră au fost încălcate, puteți depune o plângere la:
            </p>
            <div className="contact-box">
              <p><strong>Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</strong></p>
              <p>B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București</p>
              <p>Tel: +40 318 059 211</p>
              <p>Email: anspdcp@dataprotection.ro</p>
              <p>Web: www.dataprotection.ro</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>14. Contact</h2>
            <p>
              Pentru întrebări sau solicitări privind protecția datelor, contactați-ne:
            </p>
            <div className="contact-box">
              <p><strong>MULTIPOWER TOUR SRL</strong></p>
              <p>Responsabil Protecția Datelor</p>
              <p>Str. Zefirului, Nr.19, Mun. Dorohoi, Jud. Botoșani</p>
              <p>Telefon: <a href="tel:+40740824224">+4-0740-824.224</a></p>
              <p>Email: <a href="mailto:multipowertour@yahoo.com">multipowertour@yahoo.com</a></p>
              <p>Web: <a href="https://multipowertour.ro">https://multipowertour.ro</a></p>
            </div>
          </section>

          <div className="legal-footer">
            <p>
              Prin utilizarea serviciilor noastre, confirmați că ați citit și înțeles această Politică
              de Confidențialitate.
            </p>
          </div>
        </div>

        <div className="legal-navigation">
          <Link to="/termeni" className="legal-nav-link">
            ← Termeni și Condiții
          </Link>
          <Link to="/gdpr" className="legal-nav-link">
            GDPR →
          </Link>
          <Link to="/cookies" className="legal-nav-link">
            Politica Cookies →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
